import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { FaHome, FaClock, FaMoneyBill, FaCalendarAlt, FaChild, FaUser, FaEnvelope, FaWhatsapp } from "react-icons/fa"; // Importar iconos
import SvgX from "../../svg/SvgX";
import SvgArrowL from "../../svg/SvgArrowL";
import SvgHorario from "./SvgHorario";
import { MdOutlineHomeRepairService } from "react-icons/md";
import { CiSliderHorizontal, CiSliderVertical } from "react-icons/ci";

export default function ServiciosMembresia({ dataFromSubs }) {
    const [selectedService, setSelectedService] = useState(null); // Estado para almacenar el servicio seleccionado
    const [isHorizontal, setIsHorizontal] = useState(true); // Estado para alternar entre vistas horizontal y vertical

    // Función para abrir el modal con los detalles del servicio
    const openServiceDetails = (service) => {
        setSelectedService(service);
    };

    // Función para cerrar el modal
    const closeServiceDetails = () => {
        setSelectedService(null);
    };

    // Función para formatear el número de teléfono y agregar un mensaje automático
    const formatWhatsAppLink = (phone, message) => {
        if (!phone) return "";

        // Formatear el número de teléfono
        const cleaned = phone.replace(/[\s\-()]/g, "");
        const formattedPhone = cleaned.startsWith("+") ? cleaned : `${cleaned}`;

        // Codificar el mensaje para que sea válido en una URL
        const encodedMessage = encodeURIComponent(message);

        // Retornar el enlace completo
        return `https://wa.me/${formattedPhone}?text=${encodedMessage}`;
    };

    // Mensaje automático
    const automaticMessage = selectedService
        ? `Hola ${selectedService?.padres.name}, soy ${selectedService?.nana.name}, la niñera asignada para el servicio. Me gustaría coordinar los detalles del servicio. ¿Podemos hablar?`
        : "";

    return (
        <div className="mt-8 w-full">

            {/* Botón para alternar entre vistas */}
            <div className="mb-4 flex items-center justify-between">
                <h1 className="text-[#e896ef] rounded-ms  p-2 w-max">Servicios Aceptados</h1>
                <button
                    onClick={() => setIsHorizontal(!isHorizontal)}
                    className="flex items-center gap-2 bg-[#f09ff7] text-white px-4 py-2 rounded-md hover:bg-[#ebd0e7] transition-colors duration-200"
                >
                    {isHorizontal ? (
                        <>
                            <CiSliderVertical className="text-lg" />
                        </>
                    ) : (
                        <>
                            <CiSliderHorizontal className="text-lg" />
                        </>
                    )}
                </button>
            </div>

            {/* Lista de tarjetas */}
            <div
                className={`overflow-auto custom-scrollbar ${
                    isHorizontal ? "h-[300px] flex gap-6" : "grid grid-cols-1 gap-4"
                }`}
            >
                {dataFromSubs.map((service) => (
                    <motion.div
                        key={service.idFirestore}
                        whileHover={{ scale: 1.05 }}
                        whileTap={{ scale: 0.95 }}
                        className={`p-6 bg-white rounded-lg  shadow-md cursor-pointer border-l-4 border-[#e896ef] ${
                            isHorizontal ? "min-w-[300px]" : "w-full"
                        }`}
                        onClick={() => openServiceDetails(service)}
                    >
                        <h3 className="text-xl font-semibold mb-2">Barrio: {service.padres.neighborhood}</h3>

                        <p><SvgHorario typeSchedule='tarde' /></p>
                        <p className="text-gray-600"><strong>Direccion:</strong> {service.padres.address}</p>
                        <p className="text-gray-600"><strong>Días:</strong> {service.diasServicio?.join(", ") || "No especificado"}</p>
                        <p className="text-gray-600"><strong>Propuesta:</strong> ${service.propuestaEconomica}</p>
                        <p className="text-gray-600"><strong>Horario:</strong> {service.tipoHorario} </p>
                        <p className="text-gray-600"><strong>Tipo de Pago:</strong> {service.tipoPago}</p>
                        <p className="text-gray-600"><strong>Contratación:</strong> {service.tipoContratacion}</p>
                    </motion.div>
                ))}
            </div>

            {/* Modal de detalles del servicio */}
            <AnimatePresence>
                {selectedService && (
                    <motion.div
                        initial={{ opacity: 0 }}
                        animate={{ opacity: 1 }}
                        exit={{ opacity: 0 }}
                        className="fixed inset-0 bg-black bg-opacity-50 flex items-center z-50 justify-center p-4"
                        onClick={closeServiceDetails} // Cerrar modal al hacer clic fuera
                    >
                        <motion.div
                            initial={{ y: -50, opacity: 0 }}
                            animate={{ y: 0, opacity: 1 }}
                            exit={{ y: -50, opacity: 0 }}
                            className="bg-white rounded-lg p-6 w-full max-w-md"
                            onClick={(e) => e.stopPropagation()} // Evitar que el modal se cierre al hacer clic dentro
                        >
                            {/* Encabezado del modal */}
                            <div className="flex justify-between items-center mb-4">
                                <h2 className="text-xl font-bold">Detalles del Servicio</h2>
                                <button
                                    onClick={closeServiceDetails}
                                    className="text-gray-600 bg-[#e896ef] rounded-md hover:text-gray-800 transition-colors duration-200"
                                >
                                    <SvgX />
                                </button>
                            </div>

                            {/* Detalles del servicio con iconos */}
                            <div className="space-y-4 overflow-y-auto max-h-[70vh] custom-scrollbar">
                                <div className="flex items-center space-x-2">
                                    <FaHome className="text-[#e896ef]" />
                                    <p><strong>Barrio:</strong> {selectedService.padres.neighborhood}</p>
                                </div>

                                <div className="flex items-center space-x-2">
                                    <FaHome className="text-[#e896ef]" />
                                    <p><strong>Direccion:</strong> {selectedService.padres.address}</p>
                                </div>
                                <div className="flex items-center space-x-2">
                                    <MdOutlineHomeRepairService className="text-[#e896ef]" />
                                    <p><strong>Tipo de Contratación:</strong> {selectedService.tipoContratacion}</p>
                                </div>
                                <div className="flex items-center space-x-2">
                                    <FaCalendarAlt className="text-[#e896ef]" />
                                    <p><strong>Días:</strong> {selectedService.diasServicio?.join(", ") || "No especificado"}</p>
                                </div>

                                <div className="flex items-center space-x-2">
                                    <FaClock className="text-[#e896ef]" />
                                    <p><strong>Horario:</strong> {selectedService.tipoHorario}</p>
                                </div>
                                <div className="flex items-center space-x-2">
                                    <FaMoneyBill className="text-[#e896ef]" />
                                    <p><strong>Tipo de Pago:</strong> {selectedService.tipoPago}</p>
                                </div>
                                <div className="flex items-center space-x-2">
                                    <FaMoneyBill className="text-[#e896ef]" />
                                    <p><strong>Propuesta Económica:</strong> ${selectedService.propuestaEconomica}</p>
                                </div>
                                <div className="flex items-center space-x-2">
                                    <FaCalendarAlt className="text-[#e896ef]" />
                                    <p><strong>Días de Servicio:</strong> {selectedService.diasServicio.join(", ")}</p>
                                </div>
                                <div className="flex items-center space-x-2">
                                    <FaChild className="text-[#e896ef]" />
                                    <p><strong>Detalles de los Niños:</strong> {selectedService.detallesNinos}</p>
                                </div>
                                <div className="flex items-center space-x-2">
                                    <FaUser className="text-[#e896ef]" />
                                    <p><strong>Nombre del Padre:</strong> {selectedService.padres.name}</p>
                                </div>
                                <p className="flex items-center gap-2">
                                    <FaWhatsapp className="text-green-500" /> <strong>Teléfono:</strong>{" "}
                                    <a
                                        href={formatWhatsAppLink(selectedService.padres.phone, automaticMessage)}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        className="text-blue-500 hover:text-blue-700"
                                    >
                                        {selectedService.padres.phone}
                                    </a>
                                </p>
                                <div className="flex items-center space-x-2">
                                    <FaEnvelope className="text-[#e896ef]" />
                                    <p><strong>Email del Padre:</strong> {selectedService.padres.email}</p>
                                </div>
                            </div>

                            {/* Botón para volver */}
                            <div className="mt-6 flex flex-row justify-between">
                                <button
                                    onClick={closeServiceDetails}
                                    className="bg-[#f09ff7] text-white px-4 py-2 rounded-md hover:bg-[#ebd0e7] flex items-center gap-2 transition-colors duration-200"
                                >
                                    <SvgArrowL />
                                    Volver
                                </button>
                            </div>
                        </motion.div>
                    </motion.div>
                )}
            </AnimatePresence>
        </div>
    );
}